module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/user_three-31b94f3ff9bb2a7f989c9233b9e9c48b.jpeg";